import { NeutralColors, SharedColors, YammerColors } from './yammerPalette';

export const staticFluentColors = { ...SharedColors, ...NeutralColors, ...YammerColors };
export type FluentColor = keyof typeof staticFluentColors;
